import type { TranslationDict } from './ja'

export const hi: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'कैसे खेलें',
  helpAria: 'कैसे खेलें',
  settings: 'सेटिंग्स',
  settingsAria: 'सेटिंग्स',
  close: 'बंद करें',
  closeAria: 'बंद करें',
  player: 'खिलाड़ी',
  highscore: 'सर्वश्रेष्ठ स्कोर',
  start: 'गेम शुरू करें',
  staminaEmpty: 'स्टैमिना कम है',
  ranking: 'इलाका मुकाबला',
  difficultyTitle: 'कठिनाई चुनें',
  difficultyStart: 'इस कठिनाई से शुरू करें',
  back: 'वापस',
  today: 'आज',
  weekly: 'इस सप्ताह',
  alltime: 'कुल',
  loading: 'लोड हो रहा है...',
  noScores: 'अभी कोई स्कोर नहीं। पहले चैंपियन बनें!',
  loadFailed: 'लोड विफल',
  you: 'आप',
  youConstant: 'आप',
  language: 'भाषा',
  languageNote: 'जापानी सहित 18 भाषाओं का समर्थन।',
  bgm: 'BGM',
  se: 'ध्वनि प्रभाव',
  soundEnableAria: 'ध्वनि चालू करें',
  soundDisableAria: 'ध्वनि बंद करें',
  adWatch: 'पूरा विज्ञापन देखें',
  adCancel: 'अभी नहीं',
  rankSuffix: '',
  earnedPoints: 'ने {score} अंक अर्जित किए',
  helpGoalTitle: '🎯 लक्ष्य',
  helpGoalText: '9x9 बोर्ड पर अपनी गोटियाँ रखें और अपने जुड़े हुए इलाकों का विस्तार करें। सबसे अधिक स्कोर वाला खिलाड़ी जीतता है।',
  helpWinTitle: '🏆 जीत की शर्तें',
  helpWinFive: 'एक सीधी हार या तिरछी लाइन में पांच गोटियाँ जोड़कर तुरंत जीतें।',
  helpWinScore: 'यदि बोर्ड भर जाता है, तो उच्चतम स्कोर वाला जीतता है। कोई ड्रॉ नहीं होता।',
  helpScoreTitle: '💯 स्कोरिंग',
  helpLineBonus: 'लाइन बोनस: 3, 4, और 5 की लाइन बनाने पर अंक प्राप्त करें।',
  helpClusterBonus: 'इलाका बोनस: आपके जुड़े हुए समूह जितने बड़े होंगे, स्कोर उतना ही अधिक होगा।',
  helpKomi: 'कोमी: दूसरे खिलाड़ी को +10% स्कोर का लाभ मिलता है।',
  helpControlsTitle: '🖱️ नियंत्रण',
  helpControlsText: 'अपनी बारी पर, गोटी रखने के लिए एक खाली खाने पर टैप करें।',
  helpTipsTitle: '💡 सुझाव',
  helpTipHell: 'जब आप सबसे कठिन चुनौती चाहते हों, तो HELL आजमाएं।',
  helpTipCluster: 'केवल पांच की लाइन के पीछे न भागें। बड़े जुड़े हुए समूह भी आपका स्कोर बढ़ाते हैं।',
  resultWinFive: '🎉 लगातार पांच! आप जीत गए!',
  resultWinScore: '🎉 स्कोर के आधार पर जीत! आप जीत गए!',
  resultLoseFive: '😿 CPU ने लगातार पांच बना लिए!',
  resultLoseScore: '😿 स्कोर कम रहा। फिर से प्रयास करें!',
  resultDraw: '🤝 ड्रॉ',
  newHighscore: '🏆 नया सर्वश्रेष्ठ स्कोर!',
  scoreNone: 'कोई स्कोर नहीं',
  clusterBonus: 'इलाका बोनस',
  retry: 'फिर से खेलें',
  titleBack: 'शीर्षक',
  scoreHintPlaceStone: 'गोटी रखें',
  best: 'सर्वश्रेष्ठ',
  clusterUnit: 'इलाका',
  lineCount: '{len} की लाइन x{count}',
  turnCount: 'चाल {count} · {difficulty}',
  boardPlayerPiece: 'आपकी गोटी',
  boardCpuPiece: 'CPU की गोटी',
  boardPlayerAlt: 'आप',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'पंक्ति {row}, कॉलम {col}',
  boardPlaceable: 'रखा जा सकता है',
  boardEmpty: 'खाली खाना',
  boardFlower: 'फूल है',
  firstPlayerAlt: 'पहला खिलाड़ी',
  playerFirst: 'आप पहले शुरू करेंगे!',
  playerSecond: 'आप दूसरे नंबर पर खेलेंगे (+{bonus}% कोमी)',
  cpuFirst: 'CPU पहले शुरू करेगा!',
  finalePlayerWin: 'आप जीत गए!',
  finaleCpuWin: 'CPU जीत गया!',
  finaleFive: 'लगातार पांच!',
  finaleTerritory: 'इलाकों का मुकाबला!',
  winnerAlt: 'विजेता',
  loadingBoot: 'शुरू हो रहा है...',
  loadingConnect: 'कनेक्ट हो रहा है...',
  loadingProfile: 'प्रोफ़ाइल लोड हो रही है...',
  loadingAssets: 'सामग्री लोड हो रही है...',
  loadingReady: 'तैयार',
  reauthRequiredTitle: 'लॉगिन आवश्यक',
  startupFailedTitle: 'शुरू करने में विफल',
  reauthButton: 'फिर से लॉगिन करें',
  reloadButton: 'रीलोड करें',
  lineReloginButton: 'LINE लॉगिन',
  reauthReason: 'आपका लॉगिन समाप्त हो गया है। कृपया फिर से लॉगिन करें।',
  errorReauth: 'आपका लॉगिन समाप्त हो गया है। कृपया फिर से लॉगिन करें।',
  errorForbidden: 'आपको यह गेम खेलने की अनुमति नहीं है।',
  errorNotFound: 'गेम डेटा नहीं मिला।',
  errorRateLimited: 'नेटवर्क व्यस्त है। कृपया प्रतीक्षा करें और पुनः प्रयास करें।',
  errorServer: 'सर्वर से कनेक्ट नहीं हो सका। कृपया प्रतीक्षा करें और रीलोड करें।',
  errorCommunication: 'संचार त्रुटि हुई। कृपया रीलोड करें।',
  errorNetwork: 'नेटवर्क से कनेक्ट नहीं हो सका। अपना कनेक्शन जांचें और रीलोड करें।',
  errorStartup: 'शुरू करने में विफल। कृपया रीलोड करें।',
  settingsTabGeneral: 'सेटिंग्स',
  settingsTabAccount: 'खाता',
  settingsTabInfo: 'जानकारी',
  account: 'खाता',
  linked: 'लिंक किया गया',
  guest: 'अतिथि',
  loggedInWith: '{provider} के साथ लॉगिन किया',
  loggedIn: 'लॉगिन किया हुआ',
  playingAsGuest: 'आप वर्तमान में एक अतिथि के रूप में खेल रहे हैं।',
  appleLoginBusy: 'Apple के साथ लॉगिन हो रहा है...',
  appleLogin: 'Apple के साथ लॉगिन करें',
  googleLoginBusy: 'Google के साथ लॉगिन हो रहा है...',
  googleLogin: 'Google के साथ लॉगिन करें',
  logoutBusy: 'लॉगआउट हो रहा है...',
  logout: 'लॉगआउट करें',
  logoutSuccess: 'लॉगआउट सफल',
  logoutFailed: 'लॉगआउट विफल',
  appInfo: 'ऐप की जानकारी',
  appName: 'ऐप का नाम',
  version: 'संस्करण',
  legalInfo: 'कानूनी',
  terms: 'उपयोग की शर्तें',
  privacy: 'गोपनीयता नीति',
  operator: 'संचालक',
  contact: 'संपर्क',
  copyTap: 'कॉपी करने के लिए टैप करें',
  idCopied: 'ID कॉपी किया गया',
  copyFailed: 'कॉपी विफल',
  other: 'अन्य',
  reportAd: 'अनुचित विज्ञापन की रिपोर्ट करें',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'प्रोफ़ाइल संपादित करें',
  displayName: 'प्रदर्शित नाम',
  displayNamePlaceholder: 'नाम दर्ज करें',
  chooseIcon: 'आइकन चुनें',
  iconLoadFailed: 'आइकन लोड करने में विफल।',
  saveFailed: 'सहेजने में विफल। कृपया पुनः प्रयास करें।',
  noIcons: 'कोई आइकन उपलब्ध नहीं है।',
  save: 'सहेजें',
  saving: 'सहेजा जा रहा है...',
  staminaAria: 'स्टैमिना {stamina} / {max}',
  nextRecovery: 'अगला रिकवरी {time} में',
  adPlaying: 'विज्ञापन चल रहा है...',
  recoverFullAd: 'पूरी स्टैमिना पाने के लिए विज्ञापन देखें',
  dailyBonusAria: '+5 स्टैमिना के लिए पूरा विज्ञापन देखें',
  dailyBonusAd: '+5 स्टैमिना के लिए विज्ञापन देखें',
  legalLastUpdated: 'अंतिम अपडेट: {date}',
  privacyTitle: 'गोपनीयता नीति',
  termsTitle: 'उपयोग की शर्तें',
  adPlayingAria: 'विज्ञापन चल रहा है',
  adBadge: '▶ विज्ञापन',
  adRemaining: '{seconds}s शेष',
  adDevHint: 'विकास परीक्षण विज्ञापन। उत्पादन में, एक AdMob वीडियो चलेगा।',
  adRewardRequirement: 'यह इनाम पाने के लिए विज्ञापन पूरा देखें।',
  adRewardStaminaDetail: 'इनाम: स्टैमिना अधिकतम तक बहाल',
  adRewardDailyBonusDetail: 'इनाम: आज के दैनिक बोनस के रूप में +{amount} स्टैमिना',
  adRewardIncompleteNote: 'बीच में बंद करने पर इनाम नहीं मिलेगा।',
  adSkipAria: 'विज्ञापन छोड़ें',
  adSkip: 'छोड़ें ✕',
  adSkipAfter: '{seconds}s में छोड़ें',
  offlineMessage: 'सर्वर से कनेक्ट नहीं हो पा रहा है। कुछ सुविधाएं अनुपलब्ध हो सकती हैं।',
  reconnecting: 'पुनः कनेक्ट हो रहा है...',
  reconnect: 'पुनः कनेक्ट करें',
  signInTitle: 'साइन इन करें',
  signInBusy: 'साइन इन हो रहा है...',
  signInCancelNote: 'यदि आप साइन-इन रद्द करते हैं, तो आप अतिथि के रूप में जारी रख सकते हैं (कुछ सुविधाएं अनुपलब्ध होंगी)।',
  processing: 'प्रगति पर है...',
  recoverConfirmTitle: 'डेटा बदलने की पुष्टि करें',
  recoverConfirmMessage: 'इस लॉगिन से मौजूदा डेटा जुड़ा हुआ है। जारी रखने से इस डिवाइस पर अतिथि डेटा बदल जाएगा। क्या आप जारी रखना चाहते हैं?',
  recoverConfirmContinue: 'पुनर्प्राप्त करें',
  recoverConfirmCancel: 'रद्द करें',
  unlinkConfirmTitle: 'खाता अनलिंक करें',
  unlinkConfirmMessage: 'यदि आप इस प्रदाता को अनलिंक करते हैं, तो यह डिवाइस अतिथि मोड पर वापस आ जाएगा। यदि आप किसी अन्य डिवाइस पर उसी प्रदाता के साथ फिर से लॉगिन करते हैं, तो आपका हब डेटा उपलब्ध रहेगा।',
  unlinkConfirmContinue: 'अनलिंक करें',
  unlinkConfirmCancel: 'रद्द करें',
  deleteConfirmTitle: 'खाता हटाने की पुष्टि करें',
  deleteConfirmMessage: 'अपना खाता हटाने से सर्वश्रेष्ठ स्कोर, लॉगिन डेटा, लिंक किए गए खाते और आमंत्रण हट जाएंगे।\nइस क्रिया को वापस नहीं लिया जा सकता। क्या आप वाकई इसे हटाना चाहते हैं?',
  deleteConfirmContinue: 'खाता हटाएं',
  deleteConfirmCancel: 'रद्द करें',
  adNekoTitle: 'विज्ञापन बिल्ली',
  matchmakingRemaining: '{seconds}s शेष',
  matchmakingTimeoutMessage: 'समय पर कोई प्रतिद्वंद्वी नहीं मिला। कृपया पुनः प्रयास करें।',
  difficultyEasyName: 'आसान',
  difficultyEasyDescription: 'प्रतिद्वंद्वी थोड़ा ध्यान भटका हुआ है',
  difficultyNormalName: 'सामान्य',
  difficultyNormalDescription: 'प्रतिद्वंद्वी कभी-कभी गलती करता है',
  difficultyHardName: 'कठिन',
  difficultyHardDescription: 'प्रतिद्वंद्वी को बोर्ड की अच्छी समझ है',
  difficultyHellName: 'अत्यधिक',
  difficultyHellDescription: 'प्रतिद्वंद्वी मजबूत है और चालों को पहले से पढ़ लेता है',
}
